// The "Vraag overslaan" button sends this as a normal user turn. The
// interviewer prompt names the same phrase so it moves on without pushing.
export const SKIP_MESSAGE = 'Deze vraag sla ik over, dat weet ik nu niet.';
